import template from "./rent-helper.jade";

// Название куки, где хранятся записи о закрытых попапах. По пользователям и GUID форм
const COOKIE_NAME = "rentHelperBlock";
const COOKIE_DOMAIN = ".cian.ru";

export default () => {
  return {
    template,
    scope: {},
    controller: [
      '$rootScope',
      '$cookies',
      'categoryService',
      'analyticsService',
      'deviceService',
      'dealRentService',
      'config',
      function(
        $rootScope,
        $cookies,
        categoryService,
        analyticsService,
        deviceService,
        dealRentService,
        config,
      ) {
        this.isInExperiment = false;

        this.isMobile = deviceService.isMobile;
        const dealV2Enabled = config.get('dealv2.enabled');
        this.cianHelperLink = dealV2Enabled ?
          'https://promo.cian.ru/sday-snimi-2' :
          'https://promo.cian.ru/arenda-bez-riska-mo';
        this.ownLink = require('../../../resources/assets/images/rent-helper/own.png');
        this.cianHelperImageLink = require('../../../resources/assets/images/rent-helper/cianHelper.png');
        this.specialistLink = require('../../../resources/assets/images/rent-helper/specialistHelp.png');
        this.dealRentTrapText = config.get('addformConfig.rentHelperDeal.text');
        const showModalDealRentTrapInFp = !!config.get('addformConfig.rentHelperDeal.showModalDealRentTrapInFp');

        // Для каждого объявения попап показывается только один раз, определяем GUId для черновика и объявления
        const objectGuid =
          window &&
          window.addFormState &&
          window.addFormState.offer &&
          window.addFormState.offer.objectGuid || window.addFormState.objectGuid;
        const draftObjectGuid =
          window &&
          window.addFormState &&
          window.addFormState.draft &&
          window.addFormState.draft.objectGuid;

        const onDealCandidateApprove = () => {
          // eslint-disable-next-line no-param-reassign
          analyticsService.trackDealRentTrapInFpClick();
          updateCookie();
          $rootScope.$emit('addForm.updateSegments');
        };

        // Обработчики блоков
        this.handlerClickOwn = () => {
          analyticsService.trackRentHelperMyselfClick();
          updateCookie();
          $rootScope.$emit('addForm.updateSegments');
        };

        this.handlerClickHelper = () => {
          analyticsService.trackRentHelperAssistClick();
          updateCookie();
          if (showModalDealRentTrapInFp) {
            dealRentService.openTrapInFpPopup(onDealCandidateApprove);
          } else {
            window.open(this.cianHelperLink, '_blank');
            $rootScope.$emit('addForm.updateSegments');
          }
        };

        this.handlerClickSpecialist = () => {
          analyticsService.trackRentHelperSpecialistClick();
          updateCookie();

          const category = $rootScope.ad.category;
          const { dealType } = categoryService.getInfoByCategory(category);
          const query = `dealType=${dealType}&category=${category}&from=${window.location.href}`;

          window.location.href = `${window.runtime_settings.applicationFormBaseUrl}/application-form/?${query}`;
        };

        /**
         * Добавляем текущую ФП в куки, чтобы больше на ней не показывать попап.
         * Внутри куки сериализованные данные:
         * {
         *   [userId]: [Массив ID объявлений], // для авторизованных пользователей
         *   '-': 1 // для неавторизованных пользователей
         * }
         */
        const updateCookie = () => {
          let cookieValue = {};
          try {
            cookieValue = JSON.parse($cookies.get(COOKIE_NAME) || "{}");
          } catch (e) {
            throw new Error(e); // send to sentry
          }

          if (objectGuid) {
            cookieValue[objectGuid] = 1;
          }
          if (draftObjectGuid) {
            cookieValue[draftObjectGuid] = 1;
          }

          $cookies.put(COOKIE_NAME, JSON.stringify(cookieValue), {
            secure: false,
            path: "/",
            domain: COOKIE_DOMAIN,
          });
        };
      },
    ],
    controllerAs: 'rentHelperCtrl',
    replace: true,
  };
};
